const projects = [

{
    id: 1,
    title: "Habit Social",
    subtitle: "Full-Stack Social Habit Tracking Application",
    key: "MERN",
    github: "https://github.com/jmail1014/habit-social",
    URL: "https://thawing-sea-89785.herokuapp.com/",
    imgAlt: "Habit Social habit tracking application",
    description:
        "A full-stack web application combining habit tracking with social networking functionality. Users can create and track habits, share progress updates, and interact with other users through comments and reactions.",
    contributions: [
        "Built GraphQL queries and mutations",
        "Developed habit creation functionality",
        "Implemented user registration",
        "Assisted with debugging and error resolution",
        "Collaborated with a four-person development team"
    ],
    technologies: [
        "React",
        "Node.js",
        "Express",
        "MongoDB",
        "GraphQL",
        "JWT",
        "React Bootstrap"
    ]
},

{
    id: 2,
    title: "E-Commerce Backend",
    subtitle: "RESTful E-Commerce API",
    key: "orm",
    github: "https://github.com/AlexysCa/commerence-the-back-end",
    URL: "https://github.com/AlexysCa/commerence-the-back-end",
    imgAlt: "E-commerce backend API testing in Insomnia",
    description:
        "A backend API for an e-commerce application that manages products, categories, and product tags.",
    contributions: [
        "Developed RESTful API routes",
        "Implemented database models and relationships",
        "Created CRUD functionality",
        "Tested API endpoints using Insomnia"
    ],
    technologies: [
        "Node.js",
        "Express.js",
        "MySQL",
        "Sequelize",
        "REST APIs"
    ]
},

{
    id: 3,
    title: "Social Network API",
    subtitle: "NoSQL Backend Application",
    key: "NoSQL",
    github: "https://github.com/AlexysCa/The-Social-Network-NoSQLv",
    URL: "https://github.com/AlexysCa/The-Social-Network-NoSQLv",
    imgAlt: "Social network API testing in Insomnia",
    description:
        "A backend social networking API designed to manage users, thoughts, reactions, and user relationships.",
    contributions: [
        "Built API routes for users and thoughts",
        "Implemented user relationships",
        "Created reaction functionality",
        "Tested API endpoints using Insomnia"
    ],
    technologies: [
        "Node.js",
        "Express.js",
        "MongoDB",
        "Mongoose",
        "NoSQL"
    ]
},

{
    id: 4,
    title: "Think You Know JavaScript?",
    subtitle: "Interactive JavaScript Code Quiz",
    key: "code_quiz",
    github: "https://github.com/AlexysCa/think-you-know-javascript",
    URL: "https://alexysca.github.io/think-you-know-javascript/",
    imgAlt: "JavaScript code quiz application",
    description:
        "An interactive coding quiz that tests JavaScript knowledge through timed questions and dynamically generated results.",
    contributions: [
        "Built interactive quiz functionality",
        "Implemented question and answer logic",
        "Created timer functionality",
        "Developed score tracking and user feedback"
    ],
    technologies: [
        "JavaScript",
        "HTML",
        "CSS",
        "Web APIs"
    ]
},

{
    id: 5,
    title: "Note Taker",
    subtitle: "Express.js Web Application",
    key: "express_note",
    github: "https://github.com/AlexysCa/express-note-taker",
    URL: "https://peaceful-lake-35441.herokuapp.com/",
    imgAlt: "Note Taker web application",
    description:
        "A web application that allows users to create, save, view, and delete notes through a simple browser interface.",
    contributions: [
        "Built Express.js server functionality",
        "Created API routes for notes",
        "Implemented note creation and deletion",
        "Connected the frontend interface to backend functionality"
    ],
    technologies: [
        "Node.js",
        "Express.js",
        "JavaScript",
        "HTML",
        "CSS"
    ]
},

{
    id: 6,
    title: "Horiseon Website Refactor",
    subtitle: "Accessible Front-End Web Development",
    key: "horiseon",
    github: "https://github.com/AlexysCa/horiseon-challenge",
    URL: "https://alexysca.github.io/horiseon-challenge/",
    imgAlt: "Horiseon marketing website",
    description:
        "A front-end website refactoring project focused on improving semantic HTML, accessibility, code organization, and maintainability.",
    contributions: [
        "Refactored existing HTML and CSS",
        "Improved semantic HTML structure",
        "Added accessibility-focused improvements",
        "Consolidated and organized CSS"
    ],
    technologies: [
        "HTML",
        "CSS",
        "Git",
        "Web Accessibility"
    ]
},


{
id: 7,
title: "Password Generator",
subtitle: "JavaScript Web Application",
key: "js_password",
github: "https://github.com/AlexysCa/i-know-your-password",
URL: "https://alexysca.github.io/i-know-your-password/",
imgAlt: "JavaScript password generator application",
description:
"A browser-based password generator that allows users to create randomized passwords based on selected criteria.",
contributions: [
"Built the application using JavaScript",
"Implemented user-selected password criteria",
"Developed password generation logic",
"Created the interactive user interface"
],
technologies: [
"JavaScript",
"HTML",
"CSS",
"Web APIs"
]
},
];

export default projects;
